import React from 'react';
import { Table } from 'react-bootstrap';

const variables = [
    { name: '[[CLIENT]]', description: ['Nom du client'] },
    { name: '[[DATE]]', description: ["Date de l'activité"] },
    { name: '[[LIEU]]', description: ["Lieu de l'activité"] },
    {
        name: '[[CONTACTS.X]]',
        description: [
            'Nom du contact selon le rôle :',
            "0 - Planification d'activité",
            "1 - Approbation d'activité",
            '2 - Organisation de parascolaires',
            '3 - Facturation',
        ],
    },
    {
        name: '[[ACTIVITES.X]]',
        description: ["Nom de l'activité à l'index X", "* les indexes commencent à 0"],
    },
];

const LegendeCourriel = () => {
    return (
        <div>
            <span>Légende</span>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Variable</th>
                        <th>Description</th>
                    </tr>
                </thead>
                <tbody>
                    {variables.map((variable, index) => (
                        <tr key={index}>
                            <td>
                                <code>{variable.name}</code>
                            </td>
                            <td>
                                {Array.isArray(variable.description)
                                    ? variable.description.map((line, index) => <div key={index}>{line}</div>)
                                    : variable.description}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default LegendeCourriel;
